// 导入用于获取表单信息和预约信息的API方法
import {getFormInfoAPI, getReservationInfoAPI} from "@/api/flow";

const state = {
    // 流程跟踪临时变量，用于保存当前点击选人的节点信息
    processNode: {
        // 当前流程节点是否可以多选
        multiple: false
    },
    // 流程分类ID
    groupId: '',
    // 表单模版ID
    templateId: '',
    // 流程表单的所有数据
    processData: {},
    // 流程实例ID
    processInstanceId: "",
    // 流程节点ID
    taskId: '',
    // 流程表单的权限数据
    perms: [],
    // 流程表单按钮数据
    submitInfo: {},
    // 流程跟踪数据
    flowTrace: []
}

const mutations = {
    // 设置流程表单数据
    SET_PROCESS_DATA(state, data) {
        state.processData = data;
    },
    // 设置流程实例ID
    SET_PROCESS_INSTANCE_ID(state, data) {
        state.processInstanceId = data;
    },
    // 设置流程表单的权限数据
    SET_PERMS(state, data) {
        state.perms = data;
    },
    // 设置流程表单按钮数据
    SET_SUBMIT_INFO(state, data) {
        state.submitInfo = data;
    },
    // 设置表单模板ID
    SET_TEMPLATE_ID(state, data) {
        state.templateId = data;
    },
    // 设置流程分类ID
    SET_GROUP_ID(state, data) {
        state.groupId = data;
    },
    // 设置当前点击选人的节点信息
    SET_PROCESS_NODE(state, data) {
        state.processNode = data;
    },
    // 设置流程节点ID
    SET_TASK_ID(state, data) {
        state.taskId = data;
    },
    // 设置流程跟踪数据
    SET_FLOW_TRACE(state, data) {
        state.flowTrace = data;
    },
    // 清空所有流程数据，恢复默认状态
    CLEAR(state) {
        state.processData = {};
        state.processInstanceId = "";
        state.perms = [];
        state.submitInfo = {};
        state.templateId = '';
        state.groupId = '';
        state.taskId = '';
        state.flowTrace = [];
        state.processNode = {
            multiple: false
        };
    }
}

const actions = {
    // 获取流程表单信息
    getFormInfo: ({commit}, option) => {
        return new Promise(resolve => {
            // 调用获取表单信息的API
            getFormInfoAPI(option).then(res => {
                // 提交表单数据到store
                commit('SET_PROCESS_DATA', res.data);
                // 提交表单的权限数据
                commit('SET_PERMS', res.data?.currentNode?.props?.formPerms || []);
                // 组装表单提交信息
                let submitInfo = {
                    ...res.data.currentNode.props.submitInfo,
                    canHandle: res.data.canHandle, // 是否可以处理节点
                    signFlag: res.data.signFlag, // 是否需要输入意见
                    showSign: res.data.showSign, // 是否需要签名
                };
                commit('SET_SUBMIT_INFO', submitInfo);
                resolve(res);
            });
        });
    },
    // 获取流程相关信息
    getProcessInfo({commit, state}, option) {
        return new Promise((resolve, reject) => {
            // 调用获取预约信息的API
            getReservationInfoAPI(option).then(res => {
                let props = res.data?.currentNode?.props?.formPerms || [];
                // 提交表单数据到store
                commit('SET_PROCESS_DATA', res.data);
                if (!res.data.canHandle) {
                    // 如果当前用户不是节点办理人，则修改权限为只读，并设置字段为非必填
                    props.forEach(item => {
                        if (item && item.perm === 'E') {
                            item.perm = 'R'; // 修改为只读
                        }
                        if (item) {
                            item.required = false; // 设置字段为非必填
                        }
                    });
                }
                // 提交权限数据到store
                commit('SET_PERMS', props);
                // 提交流程跟踪数据到store
                commit('SET_FLOW_TRACE', res.data.taskTrackList);
                // 组装表单提交信息
                let submitInfo = {
                    ...res.data.currentNode.props.submitInfo,
                    canHandle: res.data.canHandle, // 是否可以处理节点
                    signFlag: res.data.signFlag, // 是否需要输入意见
                    showSign: res.data.showSign, // 是否需要签名
                };
                commit('SET_SUBMIT_INFO', submitInfo);
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }
}

// 导出模块配置，启用命名空间
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
